import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'js/utils/ramda.util';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import { useGetGameConfig } from './useGetGameConfig';

export const useGetUrlTypeList = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const preview = searchParams.get('preview');
    const gameTypes = useAppSelector(prop('gameTypes'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const getGameConfig = useGetGameConfig();

    return useCallback(({ gameCode, mode }) => {
        const gameConfig = getGameConfig(gameCode);
        const gameType = gameConfig[isDesktop ? 'gameType' : 'mobileGameType'];
        const provider = gameTypes.find(item => item.name === gameType);

        if (!provider) {
            return [];
        }

        let urlType;

        if (Number(preview) === 1) {
            urlType = provider[mode ? 'previewRealPlayUrl' : 'previewDemoPlayUrl'];
        }

        urlType = urlType || provider[mode ? 'realPlayUrl' : 'demoPlayUrl'];

        return [urlType];
    }, [gameTypes, preview, isDesktop, getGameConfig]);
};

